import { useQuery } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

export interface ContactDetails {
	id: string;
	name: string;
	year: string;
}

/**
 * Resolve a contact's display name + year group from GET /contact/details/{id}.
 * Used to name a student when the grid is scoped to them or a note is
 * deep-linked, since the student-scoped note feed (and the single-note
 * endpoint) don't embed the student's `About` details per note.
 */
export function useContactDetails(id?: string) {
	const { callApi, isAuthenticated } = usePymbleApi();

	return useQuery<ContactDetails | null>({
		queryKey: ["contactDetails", id],
		queryFn: async () => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const raw: any = await callApi("GET", `contact/details/${id}`);
			if (!raw?._id) return null;
			return {
				id: raw._id,
				name: raw.Name ?? "",
				year: raw.StudentInfo?.YearGroup ?? "",
			};
		},
		enabled: isAuthenticated && !!id,
		staleTime: 5 * 60 * 1000,
	});
}
